import toJSON from 'read-excel-file';
import { store } from '../../../store/index.js';
import moment from 'moment';

const parseDateValue = (value) => {
  try {
    const dateFormat = store.getters['onboardings/getDateFormatForMigration'];
    if (typeof value === 'object') return moment(value).format(dateFormat);
    else if (typeof value == 'string') {
      return moment(value, dateFormat).isValid()
        ? moment(value).format(dateFormat)
        : new Error('Invalid date');
    } else throw new Error('Invalid date');
  } catch (error) {
    console.error(error);
  }
};

const parseStringToArray = (fieldValue) => {
  if (typeof fieldValue == 'string') {
    // Check if 'value' contains is a comma-separated value
    let processedValue;
    const commaExistence = /[,]/;
    if (commaExistence.test(fieldValue)) {
      processedValue = fieldValue.split(',');
      processedValue = processedValue.map((value) => value.trim());
    } else processedValue = [fieldValue];
    return processedValue;
  } else throw new Error('Invalid data');
};

const convertExcelToJSON = ({ file, schema }) => {
  return new Promise(async (resolve, reject) => {
    await toJSON(file, { schema })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => reject(error));
  });
};

export { convertExcelToJSON, parseDateValue, parseStringToArray };
